import { createSelector } from 'reselect';

import * as Service from 'types/service';
import { PurchaseCalendarParty } from 'types';
import { filter, map } from 'es-toolkit/compat';
import { filterNilValues } from '@tock/shared/utils/typeUtils';
import { isPartyWalkIn } from 'utils/partyUtils';
import { roundTo15MinInterval } from 'utils/timeUtils';
import calendarItems from 'utils/calendarItems';
import partiesSelector from 'selectors/service/partiesSelector';

/**
 * Selector for parties to display in calendar that come from booked parties.
 */
export default createSelector(
  partiesSelector,
  (parties: Service.Party[]): PurchaseCalendarParty[] => {
    const partiesWithCalendarItem = map(parties, (party): PurchaseCalendarParty | undefined => {
      if (isPartyWalkIn(party)) {
        return undefined;
      }
      if (!party.expectedReservationTime) {
        return undefined;
      }

      const dateTime15MinuteInterval = roundTo15MinInterval(
        party.expectedReservationTime
      ).toString();
      const calendarItem = calendarItems.computeCalendarItemsForBookedParty(party);
      return {
        calendarItem,
        dateTime15MinuteInterval,
        type: 'Purchase',
        party,
      };
    });
    return filter(partiesWithCalendarItem, filterNilValues);
  }
);
